var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpaceCargoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 38,
    viewBox: "0 0 86 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.8642 14.8689L41.8523 12.8521L51.8898 12.7574L53.5433 11.2632L55.0267 13.0019L53.2568 14.7406L41.8642 14.8689Z",
    fill: "#2B63F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.1986L2.56981 12.3599L14.7443 12.2499L12.5178 9.32555L2.64443 9.39583L0.0388014 6.6671L15.0159 6.58765L18.8274 12.2224L15.9501 15.0855L0 15.1986Z",
    fill: "#2B63F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4775 4.0306L61.349 2.68915L70.1777 2.62498L72.2252 0.0856934L59.9552 0.171253L57.2988 4.05199L60.4775 4.0306Z",
    fill: "#2B63F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.26488 4.3489L5.39608 3.07773L16.5289 2.99828L19.1226 0.452881L3.64705 0.562886L0.277344 4.44973L4.26488 4.3489Z",
    fill: "#2B63F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0768 3.61249L21.0559 0.452897L36.4121 0.345947L39.4236 3.48415L21.0768 3.61249Z",
    fill: "#2B63F4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1546 15.0491L24.5721 15.0246L24.5333 9.12102L34.3827 9.05074L39.4239 3.49854L35.7467 3.52298L32.8695 6.48395L21.0979 6.56951L21.1546 15.0491Z",
    fill: "#2B63F4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5898 14.9733L36.649 14.9428L46.4686 3.45334L50.101 3.42584L59.8609 14.7808L69.1641 14.7136L70.9758 12.1254L61.1503 12.1957L51.6679 0.25708L45.3792 0.29986L32.5898 14.9733Z",
    fill: "#2B63F4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0842 14.7569L84.4736 14.6713L85.8317 12.0618L73.8929 12.1443L72.0842 14.7569Z",
    fill: "#2B63F4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1206 8.65439L84.4861 8.56883L85.8442 6.02954L73.9054 6.1151L72.1206 8.65439Z",
    fill: "#2B63F4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2461 2.62485L84.6116 2.53623L85.9726 0L74.0309 0.0825033L72.2461 2.62485Z",
    fill: "#2B63F4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91435 30.1845L11.8752 25.9095L24.1213 25.824L25.9569 23.2603L10.2903 23.3947L6.12964 29.4267L9.14715 29.8422L8.91435 30.1845Z",
    fill: "#2B63F4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32253 27.6686L0.15332 37.9999L16.4586 37.9082L18.0077 35.372L5.16759 35.4851L10.6684 27.6472",
    fill: "#2B63F4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0615 27.2573L54.0496 25.702L65.3496 25.647L67.1344 23.0833L51.3992 23.1933L51.426 27.2757",
    fill: "#2B63F4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5821 27.1791L51.4211 27.1944L51.6092 37.6418L67.228 37.5562L65.5745 35.2125L54.1103 35.2675L54.0566 27.176",
    fill: "#2B63F4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0574 27.8008L72.0425 25.4937L85.9272 25.396L85.9093 22.8689L69.0339 22.985L69.0668 27.8222L72.0574 27.8008Z",
    fill: "#2B63F4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0603 27.2313L69.129 37.5106L85.2701 37.3976L84.1628 35.0722L72.1047 35.1333L72.051 27.0876",
    fill: "#2B63F4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4129 35.1666L33.5005 23.2402L27.2804 23.2861L18.2637 37.929L21.7766 37.9045L28.6802 26.4334L31.9067 26.412L39.0818 37.7823L43.0664 37.7548L41.4129 35.1666Z",
    fill: "#2B63F4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4385 23.1902L35.3315 23.2177L37.5133 26.5576L41.6919 26.527L39.4385 23.1902Z",
    fill: "#2B63F4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0183 37.6613L43.6249 29.582L39.3748 29.6126L44.58 37.6919L49.0183 37.6613Z",
    fill: "#2B63F4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2287 37.6206L67.172 29.3091L61.0504 29.4008L59.2148 31.9431L65.0051 31.8545L65.029 35.2799",
    fill: "#2B63F4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9013 22.8694L85.9998 37.3992L82.9136 37.4206L82.8181 22.8908",
    fill: "#2B63F4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7465 23.1315L37.9624 23.1865L40.1442 26.4775L40.1681 26.5264L45.4122 26.4897C45.7196 26.4866 46.0539 26.5569 46.3404 26.6761H46.3643C47.8178 27.3453 47.3552 29.4873 45.7435 29.524H45.7196L41.5649 29.5546L42.6275 32.0755C42.6275 32.0755 52.7246 33.5361 49.728 25.5363C49.1221 24.0085 47.4328 23.1192 45.7465 23.1315Z",
    fill: "#2B63F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceCargoLogo);
export default __webpack_public_path__ + "static/media/space-cargo-logo.f370a12ecb57c5f4e9e7fa5ea1bf8267.svg";
export { ForwardRef as ReactComponent };